import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseEquipmentCategoriesProps<T> = {
  filters?: {
    search?: string;
  };
  mapper?: (data: any) => T,
};

export const useEquipmentCategories = <T,>({
  filters: { search = '' } = {},
  mapper = Mapper.default<T>(),
}: UseEquipmentCategoriesProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['equipmentCategories', search],
    queryFn: () => {
      return privateAxios.get(`/equipment_categories`, {
        params: {
          search
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
